module.exports = __webpack_public_path__ + "img/icon-close.eb3a69e5.svg";